import { render } from "./ProductGift.vue?vue&type=template&id=50fd98a9"
import script from "./ProductGift.vue?vue&type=script&lang=js"
export * from "./ProductGift.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__